<template lang="pug">
.photo-block
    .photo-block__image-wrapper
        SvUploadLight(
            :preview="uploadedImage || value.image || value.small_image || value.original_image"
            withRemove
            @input="val => change('image', val)"
            @remove="remove"
        )

</template>

<script>
/**
 * @param {Object} [value] - required - Объект с полями:
 * @field {String} [original_image] - required - Изображение, base64 или ссылка
 */
import SvUploadLight from '@/components/uikit/SvUploadLight.vue';
import SvButton from '@/components/uikit/SvButton.vue';

export default {
  name: 'PhotoBlockLight',

  data(){
    return{
      uploadedImage: null
    }
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  methods: {
    change(field, val) {
      if (field === 'image') {
        this.uploadedImage = val;
      }

      this.$emit('input', {
        ...this.value,
        [field]: val,
      });
    },

    remove() {
      this.$emit('remove');
    }
  },
  
  mounted() {
  },

  components: {
    SvButton,
    SvUploadLight,
  },
};
</script>

<style lang="scss" scoped>

.photo-block__inputs {
    margin-top: 25px;
}

.photo-block__input:last-child {
    margin-top: 20px;
}
</style>
